<template>
  <div class="app-container merchantAccount">
    <div class="section-top">
      <div class="account-balance">
        <div class="balance total">
          <div class="amount">{{balance.balance | decimal}}</div>
          <div class="balance-label">总余额</div>
        </div>
        <div class="balance cash">
          <div class="amount">
            <span>{{balance.balanceCash | decimal}}</span>
            <el-link class="btn-withdraw fr" type="danger" @click="showWithdraw">提现</el-link>
          </div>
          <div class="balance-label">可提现余额</div>
        </div>
        <div class="balance frozen">
          <div class="amount">{{balance.balanceFrozen | decimal}}</div>
          <div class="balance-label">冻结余额</div>
        </div>
        <div class="balance unsettle">
          <div class="amount">{{balance.balanceUnSettlement | decimal}}</div>
          <div class="balance-label">未结算余额</div>
        </div>
      </div>
      <div class="account-settle">
        <div class="account-settle-content" v-if="accountInfo">
          <div class="account-settle-header">
            <span class="title">账户信息</span>
            <el-link type="primary" @click="editAccount"><i class="el-icon-edit"></i> 修改</el-link>
          </div>
          <el-form :model="accountInfo" label-width="120px">
            <el-row>
              <el-col :span="12">
                <el-form-item label="账户名：">{{accountInfo.accountName}}</el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="账户号：">{{accountInfo.accountNo}}</el-form-item>
              </el-col>

            </el-row>
            <el-row>
              <el-col :span="8">
                <el-form-item label="结算方式：">{{accountInfo.accountType === 'TAX' ? '扣税点' : '开发票'}}</el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="证件号：">{{accountInfo.legalPersonIdcard}}</el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="账户类型：">{{accountInfo.accountType === 'PRI' ? '对私' : '对公'}}</el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="8">
                <el-form-item label="结算费率：">{{accountInfo.settFeeRate}}</el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="结算定额：">{{accountInfo.settFeeFixed}}</el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="结算税点：">{{accountInfo.settTax}}</el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="8">
                <el-form-item label="最低结算金额：">{{accountInfo.settMinAmount}}</el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </div>
        <div class="account-settle-empty" v-else>
          <i class="el-icon-warning-outline"></i>
          <div class="tips">暂无商户结算信息，请设置。</div>
          <el-button size="small" round plain @click="showAccountDialog">设置结算账户</el-button>
        </div>
      </div>
    </div>
    <div class="section-table">
      <el-tabs v-model="activeTable" type="card">
        <el-tab-pane label="账户流水" name="flow">
          <el-table :data="accountFlow">
            <el-table-column label="变更类型" prop="flowType">
              <template slot-scope="scope">{{flowTypes[scope.row.flowType]}}</template>
            </el-table-column>
            <el-table-column label="变更金额" prop="flowPrice">
              <template slot-scope="scope">{{scope.row.changeType === 'DECREASE' ? '-' : '+'}}{{scope.row.flowPrice | decimal}}</template>
            </el-table-column>
            <el-table-column label="变更后余额" prop="updBalance">
              <template slot-scope="scope">{{scope.row.updBalance | decimal}}</template>
            </el-table-column>
            <el-table-column label="变更时间" prop="createTime"></el-table-column>
          </el-table>
          <Pagination v-bind:child-msg="{total: flowPage.total, pageSize: flowPage.pageSize, currentPage: flowPage.pageNum}"
                      @callFather="handlePageChange($event, 'account')"></Pagination>
        </el-tab-pane>
        <el-tab-pane label="提现流水" name="withdraw">
          <el-table :data="withdrawFlow">
            <el-table-column label="账户信息" width="180">
              <template slot-scope="scope">
                <div>{{scope.row.accountName}}({{scope.row.withdrawType === 'PUB' ? '对公' : '对私'}})</div>
                <div>{{scope.row.cardNo}}</div>
                <div>{{scope.row.bankName}}</div>
              </template>
            </el-table-column>
            <el-table-column label="提现金额" prop="withdrawPrice">
              <template slot-scope="scope">{{scope.row.withdrawPrice | decimal}}</template>
            </el-table-column>
            <el-table-column label="手续费" prop="withdrawFee">
              <template slot-scope="scope">{{scope.row.withdrawFee | decimal}}</template>
            </el-table-column>
            <el-table-column label="提现扣税" prop="withdrawTax">
              <template slot-scope="scope">{{scope.row.withdrawTax | decimal}}</template>
            </el-table-column>
            <el-table-column label="到账金额" prop="withdrawActPrice">
              <template slot-scope="scope">{{scope.row.withdrawActPrice | decimal}}</template>
            </el-table-column>
            <el-table-column label="状态">
              <template slot-scope="scope">{{flowStatus[scope.row.withdrawStatus]}}</template>
            </el-table-column>
            <el-table-column label="提现时间" prop="gmtCreate"></el-table-column>
          </el-table>
          <Pagination v-bind:child-msg="{total: withdrawPage.total, pageSize: withdrawPage.pageSize, currentPage: withdrawPage.pageNum}"
                      @callFather="handlePageChange($event, 'withdraw')"></Pagination>
        </el-tab-pane>
      </el-tabs>
    </div>

    <merchant-settle-add ref="add" :default-config="defaultData" @refresh="getAccountData"></merchant-settle-add>

    <!--  提现弹窗  -->
    <el-dialog
      title="账户提现"
      :visible.sync="dialogVisible"
      width="25%"
      center
      :before-close="handleClose">
      <el-form ref="withdrawForm" :model="withdrawForm" label-width="100px">
        <el-form-item label="提现金额" prop="withdrawPrice" :rules="[
          { required: true, message: '请输入提现金额', trigger: 'change' },
          { type: 'number', min: accountInfo.settMinAmount, max: balance.balanceCash, message: '提现金额不合法', trigger: 'change' }
        ]">
          <el-input type="number" v-model.number="withdrawForm.withdrawPrice"></el-input>
        </el-form-item>
        <el-form-item label="支付密码" prop="payPassword" :rules="[
          { required: true, message: '请输入提现密码', trigger: 'change' },
        ]">
          <el-input type="password" v-model="withdrawForm.payPassword"></el-input>
        </el-form-item>
        <el-form-item label="">
          <el-link type="primary" @click="setPassword">设置支付密码 >></el-link>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="hideWithdraw">取 消</el-button>
        <el-button type="primary" @click="accountWithdraw">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script type="text/ecmascript-6">
import {
  fetchMerchantAccountDefaultData,
  fetchMerchantAccountWithdrawFlow,
  fetchMerchantAccountFlow,
  fetchMerchantAccountInfo,
  fetchMerchantAccountBalance,
  fetchMerchantWithdraw,
} from '../../api/xunyou';
import MerchantSettleAdd from './merchantSettleAdd';
import Pagination from '../../components/Pagination';
export default {
  name: 'merchantAccount',
  data() {
    return {
      dialogVisible: false,
      flowTypes: {
        'WITHDRAW': '提现'
      },
      flowStatus: {
        'PROCESS': '进行中',
        'FAIL': '失败',
        'SUCCESS': '成功'
      },
      defaultData: '',
      balance: '',
      accountInfo: '',
      activeTable: 'flow',
      flowPage: {
        pageNum: 1,
        pageSize: 10,
        total: 0
      },
      withdrawPage: {
        pageNum: 1,
        pageSize: 10,
        total: 0
      },
      accountFlow: [],
      withdrawFlow: [],
      withdrawForm: {
        withdrawPrice: null,
        payPassword: null
      }
    }
  },
  components: {
    MerchantSettleAdd,
    Pagination
  },
  computed: {
    deptId () {
      return this.$store.state.userInfo && this.$store.state.userInfo.mid;
    }
  },
  mounted() {
    this.getAccountBalance();
    this.getAccountData();
    this.getDefaultData();
    this.getAccountFlow();
    this.getWithdrawFlow();
  },
  methods: {
    setPassword () {
      this.$emit('showPassword');
    },
    handleClose(done) {
      this.withdrawForm.payPassword = null;
      this.withdrawForm.withdrawPrice = null;
      done();
    },
    // 显示提现
    showWithdraw () {
      this.dialogVisible = true;
    },
    hideWithdraw () {
      this.dialogVisible = false;
      this.withdrawForm.payPassword = null;
      this.withdrawForm.withdrawPrice = null;
    },
    // 提现
    accountWithdraw () {
      this.$refs.withdrawForm.validate(valid => {
        if (valid) {
          const params = {
            mid: this.$store.state.userInfo.mid,
            muid: this.$store.getters.userId,
            withdrawPrice: this.withdrawForm.withdrawPrice,
            payPassword: this.withdrawForm.payPassword
          }
          fetchMerchantWithdraw(params).then(res => {
            console.log('提现：', res);
            if (res.code === 0) {
              this.$message.success('提现成功！');
              this.getWithdrawFlow();
              this.getAccountFlow();
              this.hideWithdraw();
            } else {
              this.$message.error(res.msg)
            }
          }).catch(err => {
            console.error(err);
          });
        }
      });
    },
    // 翻页
    handlePageChange (val, type) {
      if (type === 'withdraw') {
        this.withdrawPage.pageNum = val.currentPage;
        this.getWithdrawFlow();
      } else {
        this.flowPage.pageNum = val.currentPage;
        this.getAccountFlow();
      }
    },
    // 查询账户流水
    getAccountFlow () {
      const params = {
        mid: this.deptId,
        pageNum: this.flowPage.pageNum,
        pageSize: this.flowPage.pageSize
      };
      fetchMerchantAccountFlow(params).then(res => {
        console.log('账户流水：', res);
        if (res.code === 0) {
          this.accountFlow = res.rows;
          this.flowPage.total = res.total;
        }
      });
    },
    // 查询提现流水
    getWithdrawFlow () {
      const params = {
        mid: this.deptId,
        pageNum: this.withdrawPage.pageNum,
        pageSize: this.withdrawPage.pageSize
      };
      fetchMerchantAccountWithdrawFlow(params).then(res => {
        console.log('提现流水：', res);
        if (res.code === 0) {
          this.withdrawFlow = res.rows;
          this.withdrawPage.total = res.total;
        }
      });
    },
    // 修改账户信息
    editAccount () {
      this.$refs.add.showDialog(this.accountInfo);
    },
    // 打开账户设置弹窗
    showAccountDialog () {
      this.$refs.add.showDialog();
    },
    // 获取账户结算信息
    getAccountData () {
      fetchMerchantAccountInfo({ mid: this.deptId }).then(res => {
        console.log('结算信息：', res);
        if (res.code === 0 && res.data) {
          this.accountInfo = res.data;
        }
      });
    },
    // 获取账户余额
    getAccountBalance () {
      fetchMerchantAccountBalance({ mid: this.deptId }).then(res => {
        console.log('账户余额：', res);
        if (res.code === 0) {
          this.balance = res.data;
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    // 获取账户默认设置
    getDefaultData () {
      fetchMerchantAccountDefaultData().then(res => {
        console.log('默认信息：', res);
        if (res.code === 0) {
          this.defaultData = res.data;
        } else {
          this.$message.error(res.msg);
        }
      });
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" rel="stylesheet/less" scoped>
.merchantAccount{
  font-size: 0;
}
.account-balance{
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: #FFFFFF;
  .balance{
    flex: 1;
    font-size: 14px;
    color: #FFFFFF;
    font-weight: 500;
    line-height: 1.3;
    padding: 10px 10px;
    border-radius: 3px;
    box-sizing: border-box;
    margin-right: 10px;
    &:last-child{
      margin-right: 0;
    }
    .btn-withdraw{
      margin-top: 5px;
    }
    .amount{
      font-size: 20px;
      font-weight: bold;
      &:before{
        content: '￥';
        font-size: 12px;
      }
    }
    &.total{
      background-color: #ff6565;
    }
    &.cash{
      background-color: #4fd785;
    }
    &.frozen{
      background-color: #ffa500;
    }
    &.unsettle{
      background-color: #2fa9ff;
    }
  }
}
.account-settle{
  font-size: 14px;
  margin-top: 10px;
  border: 1px solid #e4e7ed;
  border-radius: 5px;
  .account-settle-header{
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid #e4e7ed;
    padding: 5px;
  }
  /deep/ .el-form-item{
    margin-bottom: 0;
  }
  .account-settle-empty{
    padding: 20px 0;
    text-align: center;
    color: #888888;
    .el-icon-warning-outline{
      font-size: 2.6em;
    }
    .tips{
      font-size: 12px;
      margin-bottom: 15px;
    }
  }
}
.section-table{
  margin-top: 30px;
}
</style>



// WEBPACK FOOTER //
// src/views/siteNavigation/merchantAccount.vue